"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function InactiveIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m18.341,6.429h-6.42c-1.251-1.035-2.855-1.658-4.602-1.658C3.332,4.771.089,8.014.089,12s3.244,7.229,7.23,7.229c1.747,0,3.351-.623,4.602-1.658h6.42c3.072,0,5.571-2.499,5.571-5.571s-2.499-5.571-5.571-5.571Zm-11.022,11.102c-3.049,0-5.53-2.481-5.53-5.53s2.48-5.53,5.53-5.53,5.53,2.481,5.53,5.53-2.481,5.53-5.53,5.53Z" })));
}
exports.default = InactiveIcon;
